export enum NormalIndividualViewKeys {
  normalIndividualView_emailTableHeader = "normalIndividualView_emailTableHeader",
  normalIndividualView_actionsTableHeader = "normalIndividualView_actionsTableHeader",
  normalIndividualView_viewReportLink = "normalIndividualView_viewReportLink",
  normalIndividualView_selectReportString = "normalIndividualView_selectReportString",
}
